import { render } from "./TrainingToolDropDown.vue?vue&type=template&id=8d4bd974&ts=true"
import script from "./TrainingToolDropDown.vue?vue&type=script&lang=ts"
export * from "./TrainingToolDropDown.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__